import merge from 'lodash.merge';
import { processStep } from '@bigbank/web-loco';
import actions from './actions';
import { customPostHooks } from './customPostHooks';
import router from '../../../router';

const state = {
  application: { involveCoBorrower: undefined },
  taskData: {
    decisionReasons: [],
    firstName: '',
  },
};

const getters = {
  hasCoApplicant: state => state.application.involveCoBorrower,
  decisionReasons: state => state.taskData.decisionReasons,
  firstName: state => state.taskData.firstName,
};

// Allows setting mock client
export const createProcessStepModule = (client) => {
  const processModule = processStep.moduleBuilder(client, router, customPostHooks);

  return {
    ...processModule,
    state: merge(processModule.state, state),
    getters: merge(processModule.getters, getters),
    actions: merge(processModule.actions, actions),
  };
};
